import { useEffect, useRef, useState } from "react";
import BorderBox from "./BorderBox.jsx";
import { useGlobalContext } from "../context/GlobalContext.jsx";

import OM_Oboe from "../assets/audio/OM_Oboe.mp3";
import MEH_Oboe from "../assets/audio/MEH_Oboe.mp3";
import KHEI_Oboe from "../assets/audio/KHEI_Oboe.mp3";
import EH_Oboe from "../assets/audio/EH_Oboe.mp3";
import EHM_Oboe from "../assets/audio/EHM_Oboe.mp3";
import THO_Oboe from "../assets/audio/THO_Oboe.mp3";
import RA_Oboe from "../assets/audio/RA_Oboe.mp3";

import OM_play from "../assets/images/vowel-sounds/sound-app_OM-play.png";
import OM_stop from "../assets/images/vowel-sounds/sound-app_OM-stop.png";
import MEH_play from "../assets/images/vowel-sounds/sound-app_MEH-play.png";
import MEH_stop from "../assets/images/vowel-sounds/sound-app_MEH-stop.png";
import KHEI_play from "../assets/images/vowel-sounds/sound-app_KHEI-play.png";
import KHEI_stop from "../assets/images/vowel-sounds/sound-app_KHEI-stop.png";
import EH_play from "../assets/images/vowel-sounds/sound-app_EH-play.png";
import EH_stop from "../assets/images/vowel-sounds/sound-app_EH-stop.png";
import EHM_play from "../assets/images/vowel-sounds/sound-app_EHM-play.png";
import EHM_stop from "../assets/images/vowel-sounds/sound-app_EHM-stop.png";
import THO_play from "../assets/images/vowel-sounds/sound-app_THO-play.png";
import THO_stop from "../assets/images/vowel-sounds/sound-app_THO-stop.png";
import RA_play from "../assets/images/vowel-sounds/sound-app_RA-play.png";
import RA_stop from "../assets/images/vowel-sounds/sound-app_RA-stop.png";

import bgLight from "../assets/images/lezioni-Sound-App-bg-light.png";
import bgDark from "../assets/images/lezioni-Sound-App-bg-dark.png";
import { ArrowRightIcon } from "../assets/icons/index.js";

// Sunday=0 through Saturday=6, matches new Date().getDay()
const DAY_MAP = ["OM", "MEH", "KHEI", "EH", "EHM", "THO", "RA"];

const AUDIO = {
  OM: OM_Oboe,
  MEH: MEH_Oboe,
  KHEI: KHEI_Oboe,
  EH: EH_Oboe,
  EHM: EHM_Oboe,
  THO: THO_Oboe,
  RA: RA_Oboe,
};

const PLAY = {
  OM: OM_play,
  MEH: MEH_play,
  KHEI: KHEI_play,
  EH: EH_play,
  EHM: EHM_play,
  THO: THO_play,
  RA: RA_play,
};

const STOP = {
  OM: OM_stop,
  MEH: MEH_stop,
  KHEI: KHEI_stop,
  EH: EH_stop,
  EHM: EHM_stop,
  THO: THO_stop,
  RA: RA_stop,
};

const LEARN_MORE_URL = "https://www.rosicrucian.org/vowel-sound-app";

const VowelSoundOfTheDay = () => {
  const { darkMode } = useGlobalContext();
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const key = DAY_MAP[new Date().getDay()];

  useEffect(() => {
    const el = audioRef.current;
    if (!el) return;

    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);
    const onEnded = () => {
      setIsPlaying(false);
      el.currentTime = 0;
    };

    el.addEventListener("play", onPlay);
    el.addEventListener("pause", onPause);
    el.addEventListener("ended", onEnded);

    return () => {
      el.removeEventListener("play", onPlay);
      el.removeEventListener("pause", onPause);
      el.removeEventListener("ended", onEnded);
      el.pause();
    };
  }, []);

  const toggle = () => {
    const el = audioRef.current;
    if (!el) return;
    if (isPlaying) {
      el.pause();
      el.currentTime = 0;
    } else {
      el.play().catch(() => {});
    }
  };

  return (
    <BorderBox
      noPadding
      className="!bg-lz-paper-deep dark:!bg-lz-ink-mid !border-lz-paper-deep-border dark:!border-lz-charcoal-border"
    >
      <div className="relative w-full h-full overflow-hidden rounded-2xl">
        <img
          src={darkMode ? bgDark : bgLight}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        />

        <div className="relative z-10 flex flex-col h-full w-full">
          <div className="text-lz-candle-dim dark:text-lz-concrete text-2xl font-semibold text-center uppercase shrink-0 my-4">
            Vowel Sound of the Day
          </div>

          <div className="flex-1 min-h-0 flex items-center justify-center py-2">
            <button
              type="button"
              onClick={toggle}
              aria-pressed={isPlaying}
              aria-label={isPlaying ? `Stop ${key} tone` : `Play ${key} tone`}
              className="h-full max-h-full flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70 rounded-lg"
            >
              <img
                src={isPlaying ? STOP[key] : PLAY[key]}
                alt=""
                className="max-h-full max-w-xs h-auto w-auto object-contain"
              />
            </button>
          </div>

          <a
            href={LEARN_MORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-lz-ember hover:text-lz-ink-mid dark:text-white/90 dark:hover:text-white text-base font-bold underline text-center shrink-0 my-4"
          >
            Learn about the Vowel Sounds Mobile App{" "}
            <ArrowRightIcon className="w-4 h-4 fill-lz-ember dark:fill-white inline-block ml-1" />
          </a>
        </div>

        <audio ref={audioRef} src={AUDIO[key]} preload="auto" />
      </div>
    </BorderBox>
  );
};

export default VowelSoundOfTheDay;
